import { Breakpoint, CollapsibleBar, CollapsibleBarVariant, Disclaimer, DisclaimerVariant, IconName, Steps } from '@elearning-platform/ui';
import { useMediaQuery } from '@mui/material';
import React from 'react';

import { RouteNameEnum } from '../../enums';
import { useRedirectTo } from '../../hooks';
import LogoDark from '../../images/logoFullDark.svg';
import LogoLight from '../../images/logoFullLight.svg';
import { UseRedirectTo } from '../../interfaces';

import {
  BottomBar,
  ChildrenWrapper,
  ContentWrapper,
  DesktopImage,
  DisclaimerText,
  Logo,
  LogoWrapper,
  MainWrapper,
  MobileImage,
  RightWrapper,
  TopBar,
} from './accountSetupFrame.styled';
import { AccountSetupFrameProps } from './accountSetupFrame.types';

export const AccountSetupFrame: React.FC<AccountSetupFrameProps> = (props: AccountSetupFrameProps): JSX.Element => {
  const { children, disclaimerData, image, stepsData }: AccountSetupFrameProps = props;
  const { redirect }: UseRedirectTo = useRedirectTo();
  const isSmallDesktop: boolean = useMediaQuery(Breakpoint.SmallDesktop);

  return (
    <MainWrapper>
      {!!isSmallDesktop && (
        <CollapsibleBar
          icon={IconName.ChevronRightDouble}
          onClick={(): void => redirect({ route: RouteNameEnum.SignIn })}
          variant={CollapsibleBarVariant.Page}
        />
      )}
      <RightWrapper>
        <TopBar>
          <LogoWrapper onClick={(): void => redirect({ route: RouteNameEnum.SignIn })}>
            <Logo src={isSmallDesktop ? LogoDark : LogoLight} />
          </LogoWrapper>
          {!!stepsData && !!isSmallDesktop && (
            <Steps currentStep={stepsData.currentStep} maxSteps={stepsData.maxSteps} stepText={stepsData.stepText} />
          )}
        </TopBar>
        <ContentWrapper>
          {isSmallDesktop ? (
            <DesktopImage src={image} />
          ) : (
            <>
              <MobileImage $image={image} />
              <CollapsibleBar
                icon={IconName.ChevronLeftDouble}
                isVertical
                onClick={(): void => redirect({ route: RouteNameEnum.SignIn })}
                steps={stepsData
                  ? {
                      currentStep: stepsData.currentStep,
                      maxSteps: stepsData.maxSteps,
                      stepText: stepsData.stepText,
                    }
                  : undefined
                }
                variant={CollapsibleBarVariant.Simple}
              />
            </>
          )}
          <ChildrenWrapper>
            {children}
          </ChildrenWrapper>
        </ContentWrapper>
        {!!disclaimerData && (
          <BottomBar>
            <Disclaimer icon={IconName.Flare} title={disclaimerData.title} variant={DisclaimerVariant.Brand}>
              <DisclaimerText text={disclaimerData.text} />
            </Disclaimer>
          </BottomBar>
        )}
      </RightWrapper>
    </MainWrapper>
  );
};
